// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"_1D0o8","openButton":"_1GgU5","arrow":"_1WMzl","arrowUp":"_2tdfs","actionText":"pVHMx","preLabel":"_28J40"};